import type { WidgetLocale } from '../../types/widgetLocale';

/**
 * Обработка значения data-widget-locale
 */
export function parseWidgetLocale(value: string | undefined | null): WidgetLocale {
  if (value === 'en') {
    return 'en';
  }
  return 'ru';
}
